import style from "./EraseAndReplaceLayout.module.scss";
import EraseInfo from "../EraseInfo";
import MainBlock from "../MainBlock";
import ReplaceInfo from "../ReplaceInfo";
import TryOur from "../TryOur";
import UseCases from "../UseCases";
import FaqComponent from "../../FaqComponent/FaqComponent";
import { useStore } from "../../../stores/use_global_state";
import { addToLocalStorage } from "../../../utils/nonAuthLocalStorage";
import AuthModal from "../../AuthModal/AuthModal";
import { useState } from "react";
import TryOurTools from "../../tryOurTools/tryOurTools.jsx";
import UploadYourFile from "../../tryAITool/tryAITool.jsx";

function EraseAndReplaceLayout({ dictionary }) {
	const [showAuthModal, setShowAuthModal] = useState(false);
	const { state, dispatch } = useStore();
	const photos = [
		{ originalUrl: "/erase_and_replace/try_our/one.jpg", previewUrl: "/erase_and_replace/try_our/one_prev.png", alt: "picture one" },
		{ originalUrl: "/erase_and_replace/try_our/second.jpg", previewUrl: "/erase_and_replace/try_our/second_prev.jpg", alt: "picture two" },
		{ originalUrl: "/erase_and_replace/try_our/three.jpg", previewUrl: "/erase_and_replace/try_our/three_prev.png", alt: "picture three" },
		{ originalUrl: "/erase_and_replace/try_our/five.jpg", previewUrl: "/erase_and_replace/try_our/four_prev.png", alt: "picture four" },
		{ originalUrl: "/erase_and_replace/try_our/four.jpg", previewUrl: "/erase_and_replace/try_our/five_prev.png", alt: "picture five" },
	];

	const checkNonAuth = () => {
		if (state.isAuth) return false;
		setShowAuthModal(true);
		addToLocalStorage("erase");
		return true;
	};

	const clickHandler = (url) => {
		if (checkNonAuth()) return;
		dispatch({ type: "setEraseAndReplaceImg", img: [`${url}`], ids: null });

		setTimeout(() => {
			window.scrollTo(0, 0);
		}, 100);
	};
	return (
		<>
			<div className={style.container}>
				<MainBlock dictionary={dictionary} checkNonAuth={checkNonAuth} />
				<TryOur dictionary={dictionary} photos={photos} geEvent={"Erase & Replace"} clickHandler={clickHandler} />
				<EraseInfo dictionary={dictionary} />
				<ReplaceInfo dictionary={dictionary} />
				<UseCases dictionary={dictionary} />
				<UploadYourFile dictionary={dictionary} />
				<FaqComponent dictionary={dictionary} pageName={"page_erase"} />
				<TryOurTools t={dictionary} />
			</div>
			{showAuthModal && <AuthModal closeHandler={() => setShowAuthModal(false)} serviceName="Erase&Replace" />}
		</>
	);
}

export default EraseAndReplaceLayout;
